var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"wrapper"}},[_c('Particles',{attrs:{"id":"tsparticles","options":{
        particles: {
          number: { value: 160, density: { enable: true, value_area: 800 } },
          color: { value: '#ffffff' },
          shape: {
            type: 'circle',
            stroke: { width: 0, color: '#000000' },
            polygon: { nb_sides: 5 },
            image: { src: 'img/github.svg', width: 100, height: 100 }
          },
          opacity: {
            value: 1,
            random: true,
            anim: { enable: true, speed: 1, opacity_min: 0, sync: false }
          },
          size: {
            value: 3,
            random: true,
            anim: { enable: false, speed: 4, size_min: 0.3, sync: false }
          },
          line_linked: {
            enable: false,
            distance: 150,
            color: '#ffffff',
            opacity: 0.4,
            width: 1
          },
          move: {
            enable: true,
            speed: 1,
            direction: 'none',
            random: true,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: { enable: false, rotateX: 600, rotateY: 600 }
          }
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: { enable: true, mode: 'bubble' },
            onclick: { enable: true, mode: 'repulse' },
            resize: true
          },
          modes: {
            grab: { distance: 400, line_linked: { opacity: 1 } },
            bubble: { distance: 250, size: 0, duration: 2, opacity: 0, speed: 3 },
            repulse: { distance: 400, duration: 0.4 },
            push: { particles_nb: 4 },
            remove: { particles_nb: 2 }
          }
        },
        retina_detect: true
      }}}),_vm._m(0),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('img',{staticClass:"Logo",attrs:{"src":"/assets/images/hero.png?new","alt":"Logo"}}),_c('p',[_vm._v("84, Bancroft, Hitchin, England")]),_c('div',{staticClass:"socials"},[_c('a',{attrs:{"href":"https://discord.gg/zbgxW2YJ5E"}},[_c('img',{attrs:{"src":"/assets/images/icons/socials/discord.png","alt":"Discord"}})]),_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=bkbIjVKUc0A"}},[_c('img',{attrs:{"src":"/assets/images/icons/socials/youtube.png","alt":"Youtube"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v(" © 2022 "),_c('a',{attrs:{"href":"#"}},[_vm._v("RRG Mining")]),_vm._v(", Inc. All rights reserved ")])])}]

export { render, staticRenderFns }